/* GEHNAA v3 */
(function(){
'use strict';
var $=function(s){return document.getElementById(s)};

/* Header scroll */
var hdr=$('hdr');
window.addEventListener('scroll',function(){
  if(hdr)hdr.classList.toggle('scrolled',window.scrollY>40);
  var b=$('btt');if(b)b.classList.toggle('visible',window.scrollY>400);
},{passive:true});

/* Announcement */
var ax=$('ann-x');if(ax)ax.onclick=function(){var a=$('ann');if(a){a.style.height=a.offsetHeight+'px';setTimeout(function(){a.style.height='0';a.style.opacity='0'},10);setTimeout(function(){a.remove()},350)}};

/* Search */
var st=$('s-tog'),sb=$('s-bar'),sx=$('s-x');
if(st&&sb){st.onclick=function(){sb.classList.toggle('open');if(sb.classList.contains('open')){var i=sb.querySelector('input');if(i)setTimeout(function(){i.focus()},100)}}}
if(sx&&sb)sx.onclick=function(){sb.classList.remove('open')};

/* Cart drawer */
var cd=$('cd'),cov=$('cd-ov'),cx=$('cd-x'),ct=$('c-tog');
function openCart(){if(cd){cd.classList.add('open');document.body.style.overflow='hidden';updateShipBar()}}
function closeCart(){if(cd){cd.classList.remove('open');document.body.style.overflow=''}}
if(ct)ct.onclick=openCart;if(cx)cx.onclick=closeCart;if(cov)cov.onclick=closeCart;

/* Mobile nav */
var mn=$('mn'),mno=$('mn-ov'),mnx=$('mn-x'),bg=$('burger');
function openMob(){if(mn){mn.classList.add('open');document.body.style.overflow='hidden'}}
function closeMob(){if(mn){mn.classList.remove('open');document.body.style.overflow=''}}
if(bg)bg.onclick=openMob;if(mnx)mnx.onclick=closeMob;if(mno)mno.onclick=closeMob;

/* Escape */
document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeCart();closeMob();if(sb)sb.classList.remove('open')}});

/* Money */
function money(c){return'\u20B9'+(c/100).toFixed(2)}

/* Shipping bar */
function updateShipBar(cart){
  var fill=$('cd-ship-fill'),msg=$('cd-ship-msg');
  if(!fill||!msg)return;
  var threshold=499*100;
  try{threshold=parseInt(document.querySelector('[data-ship-threshold]').dataset.shipThreshold)*100}catch(e){}
  var total=cart?cart.total_price:0;
  if(!cart){try{var t=$('cd-total');if(t)total=parseFloat(t.textContent.replace(/[^\d.]/g,''))*100}catch(e){}}
  var pct=Math.min((total/threshold)*100,100);
  fill.style.width=pct+'%';
  if(pct>=100){msg.textContent='FREE shipping unlocked!';fill.style.background='var(--ok)'}
  else{var left=((threshold-total)/100).toFixed(0);msg.textContent='Add Rs.'+left+' more for FREE shipping!'}
}

/* Update cart badge */
function updateBadge(n){
  var b=$('c-badge');if(b)b.textContent=n;
  var c=$('cd-cnt');if(c)c.textContent='('+n+')';
}

/* Refresh cart drawer */
function refreshCart(cart){
  updateBadge(cart.item_count);
  var sub=$('cd-total');if(sub)sub.textContent=money(cart.total_price);
  var sav=$('cd-savings');
  if(sav){var saved=0;cart.items.forEach(function(i){if(i.original_line_price>i.final_line_price)saved+=i.original_line_price-i.final_line_price});
    if(saved>0)sav.textContent='You are saving '+money(saved)+'!';else sav.textContent=''}
  var body=$('cd-body');if(!body)return;
  if(cart.item_count===0){body.innerHTML='<div class="cd-empty"><p>Your bag is empty</p><a href="/collections/all" class="btn btn-p">Shop Now</a></div>';var ft=$('cd-foot');if(ft)ft.style.display='none';return}
  var h='';
  cart.items.forEach(function(item,i){var ln=i+1;
    h+='<div class="cd-item" data-line="'+ln+'"><a href="'+item.url+'"><img src="'+(item.image||'')+'" width="70" height="70" loading="lazy"></a><div class="cd-item-info"><a href="'+item.url+'" class="cd-item-t">'+item.product_title+'</a>';
    if(item.variant_title)h+='<p class="cd-item-v">'+item.variant_title+'</p>';
    if(item.original_line_price>item.final_line_price)h+='<span class="cd-item-save">Save '+money(item.original_line_price-item.final_line_price)+'</span>';
    h+='<div class="cd-item-qty"><button class="qb cd-mi" data-line="'+ln+'">-</button><span>'+item.quantity+'</span><button class="qb cd-pl" data-line="'+ln+'">+</button><button class="cd-rm" data-line="'+ln+'">Remove</button></div></div><div class="cd-item-pr">'+money(item.final_line_price)+'</div></div>';
  });
  body.innerHTML=h;
  var ft=$('cd-foot');if(ft)ft.style.display='';
  updateShipBar(cart);
  updateMilestone(cart);
}

/* Add to cart (form submit) */
document.addEventListener('submit',function(e){
  var form=e.target.closest('form[action="/cart/add"]')||e.target.closest('#atc-form');
  if(!form)return;e.preventDefault();
  var btn=form.querySelector('button[type="submit"],.pp-atc');
  var orig=btn?btn.innerHTML:'';if(btn){btn.innerHTML='Adding...';btn.disabled=true}
  var fd=new FormData(form);var data={};fd.forEach(function(v,k){data[k]=v});
  if(data.id)data.id=parseInt(data.id);if(data.quantity)data.quantity=parseInt(data.quantity);
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)})
  .then(function(r){return r.json()}).then(function(item){
    if(item.status&&item.status>=400){toast(item.description||'Could not add','error');return}
    toast('Added to cart!');return fetch('/cart.js').then(function(r){return r.json()});
  }).then(function(cart){if(cart){refreshCart(cart);setTimeout(openCart,300)}})
  .catch(function(){toast('Something went wrong','error')})
  .finally(function(){if(btn){btn.innerHTML=orig;btn.disabled=false}});
});

/* Quick add */
document.addEventListener('click',function(e){
  var qa=e.target.closest('[data-quick-add]');if(!qa)return;
  var vid=qa.dataset.variantId;if(!vid)return;
  var orig=qa.textContent;qa.textContent='...';qa.disabled=true;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(vid),quantity:1})})
  .then(function(r){return r.json()}).then(function(){toast('Added to cart!');return fetch('/cart.js').then(function(r){return r.json()})})
  .then(function(cart){if(cart){refreshCart(cart);setTimeout(openCart,300)}}).catch(function(){})
  .finally(function(){qa.textContent=orig;qa.disabled=false});
});

/* Cart drawer qty */
document.addEventListener('click',function(e){
  var mi=e.target.closest('.cd-mi'),pl=e.target.closest('.cd-pl'),rm=e.target.closest('.cd-rm');
  if(!mi&&!pl&&!rm)return;
  var t=mi||pl||rm,ln=parseInt(t.dataset.line),item=t.closest('.cd-item');
  var qEl=item?item.querySelector('.cd-item-qty span'):null;
  var q=qEl?parseInt(qEl.textContent):1;
  if(mi)q=Math.max(0,q-1);if(pl)q++;if(rm)q=0;
  if(qEl&&q>0)qEl.textContent='...';if(rm&&item)item.style.opacity='.3';
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:ln,quantity:q})})
  .then(function(r){return r.json()}).then(refreshCart).catch(function(err){console.error(err)});
});

/* Wishlist */
function getWL(){try{return JSON.parse(localStorage.getItem('g_wl')||'[]')}catch(e){return[]}}
function saveWL(l){localStorage.setItem('g_wl',JSON.stringify(l))}
document.addEventListener('DOMContentLoaded',function(){
  var wl=getWL();document.querySelectorAll('[data-wishlist]').forEach(function(b){if(wl.indexOf(b.dataset.wishlist)>-1)b.classList.add('active')});
});
document.addEventListener('click',function(e){
  var wb=e.target.closest('[data-wishlist]');if(!wb)return;e.preventDefault();
  var pid=wb.dataset.wishlist,list=getWL(),idx=list.indexOf(pid);
  if(idx>-1){list.splice(idx,1);toast('Removed from wishlist')}else{list.push(pid);toast('Added to wishlist!')}
  saveWL(list);document.querySelectorAll('[data-wishlist="'+pid+'"]').forEach(function(b){b.classList.toggle('active',list.indexOf(pid)>-1)});
});

/* Product page */
document.addEventListener('DOMContentLoaded',function(){
  var mainImg=$('main-img'),thumbs=document.querySelectorAll('.pp-th'),ci=0;
  thumbs.forEach(function(th,i){th.addEventListener('click',function(e){
    e.preventDefault();var src=this.dataset.src;if(!mainImg||!src)return;
    thumbs.forEach(function(t){t.classList.remove('active')});this.classList.add('active');ci=i;
    mainImg.style.opacity='.3';var tmp=new Image();
    tmp.onload=function(){mainImg.src=src;mainImg.style.opacity='1'};
    tmp.onerror=function(){mainImg.src=src;mainImg.style.opacity='1'};tmp.src=src;
  })});
  /* Arrows */
  var ppPrev=$('pp-prev'),ppNext=$('pp-next');
  if(ppPrev)ppPrev.onclick=function(){if(ci>0){ci--;thumbs[ci].click()}};
  if(ppNext)ppNext.onclick=function(){if(ci<thumbs.length-1){ci++;thumbs[ci].click()}};
  /* Mobile swipe */
  if(mainImg&&thumbs.length>1){var sx=0;
    mainImg.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
    mainImg.addEventListener('touchend',function(e){var d=sx-e.changedTouches[0].clientX;if(Math.abs(d)>50){if(d>0&&ci<thumbs.length-1){ci++;thumbs[ci].click()}else if(d<0&&ci>0){ci--;thumbs[ci].click()}}},{passive:true})}
  /* Qty */
  var qmi=$('q-mi'),qpl=$('q-pl'),qi=$('pp-q');
  if(qmi)qmi.onclick=function(){if(qi)qi.value=Math.max(1,parseInt(qi.value||1)-1)};
  if(qpl)qpl.onclick=function(){if(qi)qi.value=parseInt(qi.value||1)+1};
  /* Variant buttons */
  document.querySelectorAll('.pp-ob').forEach(function(b){b.onclick=function(){this.parentElement.querySelectorAll('.pp-ob').forEach(function(s){s.classList.remove('active')});this.classList.add('active')}});
  /* Newsletter */
  document.querySelectorAll('.nl-form').forEach(function(f){f.onsubmit=function(e){e.preventDefault();var em=f.querySelector('input[type="email"]');if(!em||!em.value)return;
    fetch('/contact',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:'form_type=customer&utf8=%E2%9C%93&contact%5Bemail%5D='+encodeURIComponent(em.value)+'&contact%5Btags%5D=newsletter'})
    .then(function(){toast('Subscribed!');f.reset()}).catch(function(){toast('Error','error')})}});
});

/* Hero slider */
var slides=document.querySelectorAll('.hero-s'),dots=document.querySelectorAll('.hero-dot'),cur=0,si;
function go(i){if(!slides.length)return;slides[cur].classList.remove('active');if(dots[cur])dots[cur].classList.remove('active');cur=(i+slides.length)%slides.length;slides[cur].classList.add('active');if(dots[cur])dots[cur].classList.add('active')}
if(slides.length>1){si=setInterval(function(){go(cur+1)},5000);
  dots.forEach(function(d,i){d.onclick=function(){clearInterval(si);go(i);si=setInterval(function(){go(cur+1)},5000)}});
  var hp=document.querySelector('.hero-prev'),hn=document.querySelector('.hero-next');
  if(hp)hp.onclick=function(){clearInterval(si);go(cur-1);si=setInterval(function(){go(cur+1)},5000)};
  if(hn)hn.onclick=function(){clearInterval(si);go(cur+1);si=setInterval(function(){go(cur+1)},5000)}}

/* Scroll reveal */
var fades=document.querySelectorAll('.fade-up');
if('IntersectionObserver' in window){var obs=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('visible');obs.unobserve(en.target)}})},{threshold:.1,rootMargin:'0px 0px -30px 0px'});fades.forEach(function(el){obs.observe(el)})}else{fades.forEach(function(el){el.classList.add('visible')})}

/* Back to top */
var btt=$('btt');if(btt)btt.onclick=function(){window.scrollTo({top:0,behavior:'smooth'})};

/* Toast */
function toast(msg,type){var t=$('toast');if(!t)return;t.textContent=msg;t.className='toast show '+(type||'');clearTimeout(t._t);t._t=setTimeout(function(){t.classList.remove('show')},3000)}
window.showToast=toast;

})();

/* === CART MILESTONE PROGRESS BAR === */
function updateMilestone(cart){
  var fill=document.getElementById('cd-mile-fill');
  var msg=document.getElementById('cd-mile-sub');
  var savBar=document.getElementById('cd-savings-bar');
  var markers=document.getElementById('cd-mile-markers');
  if(!fill)return;
  var total=cart?cart.total_price/100:0;
  var milestones=window.__cartMilestones||[];
  if(!milestones.length)return;
  var maxVal=milestones[milestones.length-1].val;
  var pct=Math.min((total/maxVal)*100,100);
  fill.style.width=pct+'%';
  
  /* Render markers dynamically */
  if(markers&&!markers.dataset.rendered){
    markers.innerHTML='';
    milestones.forEach(function(m,i){
      var pos=((m.val/maxVal)*100);
      var el=document.createElement('div');
      el.className='cd-mile-m';el.dataset.val=m.val;
      el.style.left=pos+'%';
      el.innerHTML='<span class="cd-mile-icon">&#127873;</span><span>'+m.name+'</span><span class="cd-mile-val">'+m.val+'</span>';
      markers.appendChild(el);
    });
    markers.dataset.rendered='1';
  }
  
  /* Find next milestone */
  var nextM=null;
  for(var i=0;i<milestones.length;i++){
    if(total<milestones[i].val){nextM=milestones[i];break}
  }
  
  /* Update marker states */
  document.querySelectorAll('.cd-mile-m').forEach(function(m){
    var val=parseInt(m.dataset.val);
    m.classList.toggle('unlocked',total>=val);
  });
  
  if(msg){
    if(nextM){msg.textContent='You are Rs.'+(nextM.val-total).toFixed(0)+' away to unlock next milestone!'}
    else{msg.textContent='Congrats! You unlocked best discounts!'}
  }
  
  /* Savings bar */
  if(savBar&&cart){
    var saved=0;
    cart.items.forEach(function(i){if(i.original_line_price>i.final_line_price)saved+=i.original_line_price-i.final_line_price});
    if(saved>0){savBar.textContent='You are saving Rs.'+(saved/100).toFixed(0)+'!';savBar.className='cd-savings-bar has-savings'}
    else{savBar.textContent='';savBar.className='cd-savings-bar'}
  }
  /* Compare price */
  var cmp=document.getElementById('cd-compare');
  if(cmp&&cart){
    var orig=0;cart.items.forEach(function(i){orig+=i.original_line_price});
    if(orig>cart.total_price){cmp.textContent=money(orig);cmp.style.display=''}
    else{cmp.style.display='none'}
  }
}

/* Patch refreshCart to also call updateMilestone */
var _origRefresh=window._refreshCartRef;
(function(){
  var origRefreshCart=null;
  /* Override by re-calling after cart updates */
  var observer=new MutationObserver(function(){
    /* When cart body changes, recalculate milestone */
    try{
      var totalEl=document.getElementById('cd-total');
      if(totalEl){
        var val=parseFloat(totalEl.textContent.replace(/[^\d.]/g,''));
        if(!isNaN(val))updateMilestone({total_price:val*100,items:[]});
      }
    }catch(e){}
  });
  var cdBody=document.getElementById('cd-body');
  if(cdBody)observer.observe(cdBody,{childList:true,subtree:true});
})();

/* Initial milestone update */
document.addEventListener('DOMContentLoaded',function(){
  try{
    var totalEl=document.getElementById('cd-total');
    if(totalEl){
      var val=parseFloat(totalEl.textContent.replace(/[^\d.]/g,''));
      if(!isNaN(val))updateMilestone({total_price:val*100,items:[]});
    }
  }catch(e){}
});

/* === END === */
